export const EOIRCaseInfoGetters = {}
